<template>
  <div>
    <el-row class="grid-table">
      <el-form :inline="true" :model='data'>
        <el-form-item label="分类">
          <el-select v-model="search_data.examType">
            <el-option v-for="item in examTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="search" type="primary" @click='onSearch'>查询</el-button>
          <el-button icon="plus" @click="addExam" :disabled="grade.examAdd">生成试卷
          </el-button>
        </el-form-item>
      </el-form>
      <el-table stripe border style="width:100%;margin-top:10px" :data="table_data.data">
        <el-table-column prop="examTitle" label="试卷标题"></el-table-column>
        <el-table-column prop="examType" label="试卷类型"></el-table-column>
        <el-table-column prop="author.nickname" label="出卷人"></el-table-column>
        <el-table-column prop="totalScores" label="参考总分"></el-table-column>
        <el-table-column prop="time" label="答题时间" :formatter="tableFormatter('minsToFixed','time')"></el-table-column>
        <el-table-column label="开卷时间">
          <template slot-scope="scope">
            {{strategyMap['dateFormat'](scope.row.date[0],'yyyy-MM-dd')}}至{{strategyMap['dateFormat'](scope.row.date[1],'yyyy-MM-dd')}}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{getState(scope.row.date)}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="shouldBe(scope.row.date)" type="primary" @click="doExercise(scope.row,scope.$index)" :disabled="scope.row.haveExercised">开始答题</el-button>
            <el-button v-if="!shouldBeElse(scope.row.date)" @click="goDetail(scope.row.objectId)">查看</el-button>
            <el-button @click="addExam(scope.row.objectId)" :disabled="grade.examEdit">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-size="search_data.pageSize"
        layout="total, prev, pager, next,jumper"
        :total="table_data.total">
      </el-pagination>
    </el-row>
  </div>
</template>
<script type="text/javascript">
import utils from '@/utils/index'
import { tableFormatter,strategyMap } from "@/utils/formatter.js";
import common from '@/../server/common'
import '@/components/index'

export default {
  name: 'list',
  data () {
    return {
      tableFormatter,
      strategyMap,
      page_grade: common.page_grade,
      grade: {
        examAdd: !0,
        examEdit: !0
      },
      examTypes: common.examTypes,
      search_data: {
        examType: 1,
        page: 1,
        pageSize: 10
      },
      table_data: {
        total: 0,
        data: []
      },
      loading: false,
    }
  },
  methods: {
    addExam (id) {
      this.$router.push({path:'/exam/add',query:{id}});
    },
    goDetail(id){
      this.$router.push('/exam/detail?id='+id);
    },
    shouldBe(dateArray){
      const tag = new Date(dateArray[0])<new Date() && new Date(dateArray[1])>new Date();
      return tag;
    },
    shouldBeElse(dateArray){
      const tag = new Date(dateArray[0])>new Date() || new Date(dateArray[1])>new Date()
      return tag;
    },
    async doExercise(row,index){
      try {
        await this.$confirm(`确认开始答题？答题开始后将不能再次答题。此次答题参考时间为${row.time}分钟，超时将自动提交答题结果`);
        utils.ajax.call(this, '/startExercise', {examId:row.objectId,examType:this.search_data.examType}, (obj, err) => {
        if (!err) {
          if(obj.haveExercised){
            this.$set(row,'haveExercised',obj.haveExercised);
            this.$message.warning("你已经答过题不能再进行测试了！");
          }else{
            this.$router.push('/exam/exercise?examId='+row.objectId+'&recordId='+obj.objectId);
          }
        }
      })
      } catch (error) {
        console.log(error);
      }
    },
    getState(dateArray){
      if(this.shouldBe(dateArray)){
        return '剩余答题时间' + Math.floor((new Date(dateArray[1]) - new Date()) / 1000 / 60 / 60 ) + '小时';
      }
      if(this.shouldBeElse(dateArray)){
        return '暂未到开始时间'
      }else{
        return '已过答题时间'
      }
    },
    // ajax请求列表数据
    ajaxData () {
      utils.ajax.call(this, '/examList', this.search_data, (obj, err) => {
        if (!err) {
          this.table_data.data = obj.list
          this.table_data.total = obj.total
          this.search_data.page = obj.page
        }
      })
    },
    // 点击查询
    onSearch () {
      this.search_data.page = 1
      this.ajaxData()
    },
    handleCurrentChange (page) {
      if (page !== this.search_data.page) {
        this.search_data.page = page
        this.ajaxData()
      }
    }
  },
  mounted () {
    this.ajaxData()
  },
  mixins: [common.mixin]
}
</script>
<style lang="less">
  .grid-table {
    .el-form-item {
      display: inline-block;
      max-height: 240px;
      width: ~'calc(24% - 10px)';
      &:first-child {
        .el-input {
          margin-right: 25px;
        }
      }
      &:last-child {
        overflow: hidden;
        white-space: nowrap;
        vertical-align: bottom;
      }
    }
    .el-pagination {
      margin-top: 5px;
      text-align: right;
    }
    .el-cascader--small .el-cascader__label {
      line-height: 40px;
    }
  }
</style>
